import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  container: {
    width: '338px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '16px',
  },
  formRow: {
    display: 'flex',
    gap: '16px',
  },
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    flex: 1,
  },
  actionsRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  saveActions: {
    display: 'flex',
    gap: '8px',
  },
  checkbox: {
    '& .MuiFormControlLabel-label': {
      fontSize: '12px',
    },
    '& input[type=checkbox]': {
      height: 'auto',
      width: 'auto',
      position: 'static',
      top: 'auto',
      marginRight: '0',
      minHeight: 'unset',
      boxShadow: 'none',
    },
  },
  numberInput: {
    '& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button': {
      display: 'none',
    },
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
  },
});
